<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <loading-provider :loading="pageLoading">
      <template v-if="unLockTakeawayWeb">
        <page-header class="py-4 pb-6">
          {{ $t('PickUpAndDeliveryManagement') }}
          <template #subtitle>
            {{ $t('PickUpAndDeliveryManagementSubtitle') }}
          </template>
        </page-header>
        <v-card
          :class="$vuetify.breakpoint.lgAndUp ? 'px-12' : ''"
          class="py-6 mt-4"
          color="#f1f1f1"
          flat
        >
          <div
            :style="!$vuetify.breakpoint.lgAndUp ? 'grid-template-columns: repeat(1, minmax(0,1fr));' : 'grid-template-columns: repeat(2, minmax(0,1fr));'"
            style="display: grid;grid-gap: 48px"
          >
            <div class="pa-4 d-flex flex-column justify-center align-center">
              <v-card
                class="pa-4"
                elevation="0"
                width="240"
              >
                <v-responsive :aspect-ratio="1">
                  <v-img
                    :src="QRCodeHeader+takeawayAddress"
                    lazy-src="@/assets/logonew.png"
                  />
                </v-responsive>
              </v-card>

              <v-btn
                class="mt-4 blue lighten-3"
                outlined
                @click="downloadQr()"
              >
                {{ $t('clickToDownloadQr') }}
              </v-btn>

              <div
                class="mt-6"
                style="height: 24px"
              >
                <a
                  :href="takeawayAddress"
                  style="color:#000; text-decoration: underline"
                  target="_blank"
                >{{ takeawayAddress }}</a>
              </div>
            </div>
            <div>
              <v-card
                :class="!$vuetify.breakpoint.lgAndUp ? 'rounded-tr-0 rounded-tl-0' : ''"
                class="pa-7"
                elevation="0"
              >
                <div class="d-flex align-baseline">
                  <div
                    :style="{width: titleWidth}"
                  >
                    <div
                      class="text-body-2"
                    >
                      {{ $t('PickUpAndDeliveryServiceToggle') }}
                    </div>
                  </div>

                  <div
                    class="d-flex justify-end align-baseline"
                    style="width: 50%;max-width: 300px"
                  >
                    <v-switch
                      v-model="currentlyOpening"
                      :disabled="switchTimeDisabled"
                      class="switchClass"
                      dense
                      @change="switchWebEnable"
                    />
                  </div>
                </div>

                <v-divider class="my-4" />
                <div
                  class="d-flex align-center"
                >
                  <div
                    :style="{width: titleWidth}"
                    class="text-body-2"
                  >
                    <div>
                      {{ $t('PickupDiscount') }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      style="color: grey; max-width: 240px"
                    >
                      {{ $t('PickupDiscountSubtitle') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div style="width: 50%;max-width: 300px">
                    <v-text-field
                      v-model="pickDiscount"
                      :hint="$t('DiscountArea') + '0~100%'"
                      dense
                      hide-details
                      outlined
                      persistent-hint
                      suffix="%"
                      type="Number"
                    />
                  </div>
                </div>
                <v-divider class="my-4" />
                <div
                  class="d-flex align-center"
                >
                  <div
                    :style="{width: titleWidth}"
                    class="text-body-2"
                  >
                    <div>
                      {{ $t('DeliveryService') }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      style="color: grey; max-width: 240px"
                    >
                      {{ $t('DeliveryTakeawaySubtitle') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div style="width: 50%;max-width: 300px">
                    <v-select
                      v-model="webInfo.hideDelivery"
                      :items="hideDeliveryOptions"
                      :menu-props="{outline: true, contentClass:'elevation-2 ikRounded', nudgeBottom: '64px'}"
                      dense
                      hide-details
                      item-text="label"
                      item-value="value"
                      outlined
                      persistent-hint
                    />
                  </div>
                </div>
                <v-divider class="my-4" />
                <div
                  class="d-flex align-center"
                >
                  <div
                    :style="{width: titleWidth}"
                    class="text-body-2"
                  >
                    <div>
                      {{ $t('pickUp') }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      style="color: grey; max-width: 240px"
                    >
                      {{ $t('storeProvidePickUpService') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div style="width: 50%;max-width: 300px">
                    <v-select
                      v-model="webInfo.selfPickUp"
                      :items="pickUpOptions"
                      :menu-props="{outline: true, contentClass:'elevation-2 ikRounded', nudgeBottom: '64px'}"
                      dense
                      hide-details
                      item-text="label"
                      item-value="value"
                      outlined
                      persistent-hint
                    />
                  </div>
                </div>
                <v-divider class="my-4" />
                <div
                  class="d-flex align-center"
                >
                  <div
                    :style="{width: titleWidth}"
                    class="text-body-2"
                  >
                    <div>
                      {{ $t('timeSetting') }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      style="color: grey; max-width: 240px"
                    >
                      {{ $t('orderTodayTakeaway') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div style="width: 50%;max-width: 300px">
                    <v-select
                      v-model="webInfo.onlyOrderToday"
                      :items="booleanOptions"
                      :menu-props="{outline: true, contentClass:'elevation-2 ikRounded', nudgeBottom: '64px'}"
                      dense
                      hide-details
                      item-text="label"
                      item-value="value"
                      outlined
                      persistent-hint
                    />
                  </div>
                </div>
                <v-divider class="my-4" />
                <div
                  class="d-flex align-center"
                >
                  <div
                    :style="{width: titleWidth}"
                    class="text-body-2"
                  >
                    <div>
                      {{ $t('useDefaultTime') }}
                    </div>
                    <div
                      class="text-caption mt-1"
                      style="color: grey; max-width: 240px"
                    >
                      {{ $t('autoUse15MinTimeRules') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div style="width: 50%;max-width: 300px">
                    <v-select
                      v-model="webInfo.useDefaultTime"
                      :items="booleanOptions"
                      :menu-props="{outline: true, contentClass:'elevation-2 ikRounded', nudgeBottom: '64px'}"
                      dense
                      hide-details
                      item-text="label"
                      item-value="value"
                      outlined
                      persistent-hint
                    />
                  </div>
                </div>
                <template v-if="$vuetify.breakpoint.lgAndUp">
                  <v-btn
                    :loading="isLoading"
                    block
                    class="mt-8"
                    color="amber black--text lighten-4"
                    depressed
                    large
                    light
                    @click="saveDataEvent"
                  >
                    <v-icon
                      class="mr-4"
                      large
                      left
                    >
                      mdi-check-circle
                    </v-icon>
                    {{ $t('Update') }}
                  </v-btn>
                </template>
                <template v-else>
                  <fab-button
                    :fab-loading="isLoading"
                    background="#ffeb7e"
                    color="black"
                    fab-bottom
                    fab-fixed
                    fab-right
                    icon="mdi-check-circle"
                    @click-event="saveDataEvent"
                  />
                </template>
              </v-card>
            </div>
          </div>
        </v-card>
      </template>
      <template v-else>
        <not-active-page
          :product-name="$t('PickUpAndDeliveryService')"
          @click="showActiveDialog=true"
        />
      </template>
    </loading-provider>

    <v-dialog
      v-model="showUploadDialog"
      max-width="600"
      persistent
    >
      <img-upload-dialog
        v-model="showUploadDialog"
        :img-url="webInfo.bannerImagePath"
        class="pa-4"
        @getNewImgUrl="getNewImgUrl"
      />
    </v-dialog>

    <v-dialog
      v-model="showActiveDialog"
      max-width="600"
      persistent
    >
      <active-takeaway-web-dialog
        v-model="showActiveDialog"
        :all-records="allRecords"
        :all-subdomain-name="allRecordsSubdomainName"
        class="pa-6"
        @reloadTakeawayPage="loadStore"
      />
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ImgUploadDialog from '@/views/AadenPages/extraModules/takeaway/components/imgUploadDialog.vue'

import {
  getDataterminalByDeviceId,
  setRecords,
  syncData,
  syncTakeawaySettingToCloud
} from '@/model/dataLayer/api/takeaway/TakeawayManager'
import ActiveTakeawayWebDialog from '@/views/AadenPages/extraModules/takeaway/components/activeTakeawayWebDialog.vue'
import FabButton from '@/views/AadenPages/components/FabButton/FabButton.vue'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import { getNiceRestaurantInfo } from '@/model/dataLayer/service/otherService'
import i18n from '@/i18n'
import NotActivePage from '@/views/SaaS/widget/NotActivePage.vue'
import GlobalSettings from '@/model/global/GlobalSettings'
import { checkNewRecords, checkOldRecords } from '@/model/firebase/takewayCompat'
import LoadingProvider from '@/views/widget/LoadingProvider'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export default {
  name: 'TakeawayWeb.vue',
  components: {
    LoadingProvider,
    NotActivePage,
    ActiveTakeawayWebDialog,
    ImgUploadDialog,
    PageHeader,
    FabButton
  },
  data () {
    return {
      switchTimeDisabled: false,
      allRecords: [],
      allRecordsSubdomainName: [],
      pageLoading: false,
      webInfo: {
        selfPickUp: 'false',
        subdomainName: 'xxyyzz',
        dataTerminalId: '',
        bannerImagePath: '',
        pickDiscountStr: '0p',
        hideDelivery: 'false',
        shopHomepageUrl: '',
        useDefaultTime: 'true'
      },
      pickDiscount: 0,
      lastModify: dayjs().toISOString(),
      showUploadDialog: false,
      showActiveDialog: false,
      hideDeliveryOptions: [
        {
          label: i18n.t('Delivery'),
          value: 'false'
        },
        {
          label: i18n.t('NoDelivery'),
          value: 'true'
        }
      ],
      pickUpOptions: [
        {
          label: '允许自提',
          value: 'true'
        },
        {
          label: '不允许自提',
          value: 'false'
        }
      ],
      booleanOptions: [
        {
          label: '是',
          value: 'true'
        },
        {
          label: '否',
          value: 'false'
        }
      ],
      titleWidth: '48%',
      disable: true,
      editAble: false,
      isLoading: false,
      isSync: false,
      takeawayAddress: '',
      QRCodeHeader: 'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=',
      restaurantInfo: null,
      // ngrokEnable: false,
      currentlyOpening: false,
      unLockTakeawayWeb: false
    }
  },
  computed: {},
  watch: {},
  async mounted () {
    await this.loadStore()
  },
  methods: {

    downloadQr () {
      const url = this.QRCodeHeader + this.takeawayAddress
      fetch(url).then(async res => await res.blob()).then((blob) => {
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = URL.createObjectURL(blob)
        a.download = GlobalSettings.DeviceId + '二维码'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },

    async loadStore () {
      this.pageLoading = true
      const storeId = await getCurrentDeviceId()
      const newRecords = (await checkNewRecords())
      const oldRecords = (await checkOldRecords())
      const allRecords = newRecords.concat(oldRecords)
      this.allRecordsSubdomainName = allRecords.map(it => it.subdomainName)
      try {
        const tempDataTermialId = (await getDataterminalByDeviceId(storeId))?.id
        await this.getTakeawayWebEnabledInfo()

        // 门店在 cloud-minus 上没有 dataterminal 时 tempDataTermialId 为 undefined；Firestore 记录也不一定有 deviceId/dataTerminalId
        const data = allRecords.find(
          s => String(s.deviceId) === String(storeId) ||
            (tempDataTermialId != null && String(s.dataTerminalId) === String(tempDataTermialId)))
        if (data) {
          this.takeawayAddress = ''
          this.webInfo = Object.assign(this.webInfo, data)
          this.pickDiscount = parseInt(
            this.webInfo.pickDiscountStr.substring(0, this.webInfo.pickDiscountStr.length - 1)) ?? 0
          this.unLockTakeawayWeb = true
          const urlProtocol = location.protocol + '//'
          this.takeawayAddress = urlProtocol + this.webInfo.subdomainName + '.takeaway.aaden.io'
        } else {
          this.unLockTakeawayWeb = false
        }
      } catch (e) {
        console.log(e)
      }
      this.pageLoading = false
    },

    async getTakeawayWebEnabledInfo () {
      try {
        this.restaurantInfo = await getNiceRestaurantInfo()
        this.currentlyOpening = this.restaurantInfo?.currentlyOpening.toString() === '1'
        // this.ngrokEnable = await checkVersionPass()
      } catch (e) {
        console.log(e)
      }
    },

    async switchWebEnable () {
      this.isLoading = true
      this.switchTimeDisabled = true

      try {
        const info = Object.assign({}, this.restaurantInfo)
        info.currentlyOpening = this.currentlyOpening ? 1 : 0

        await syncTakeawaySettingToCloud(info)
      } catch (e) {
        console.log(e)
      }
      this.isLoading = false
      setTimeout(() => {
        this.switchTimeDisabled = false
      }, 1000 * 10)
    },

    async saveDataEvent () {
      try {
        this.isLoading = true
        this.webInfo.pickDiscountStr = this.pickDiscount + 'p'
        await setRecords(
          this.webInfo.subdomainName,
          this.webInfo.dataTerminalId,
          this.webInfo.bannerImagePath,
          this.webInfo.pickDiscountStr,
          this.webInfo.hideDelivery,
          this.webInfo.shopHomepageUrl,
          this.webInfo.selfPickUp,
          this.webInfo.onlyOrderToday,
          this.webInfo.useDefaultTime)
        await this.syncDataEvent()
        this.editAble = false
        this.isLoading = false
      } catch (e) {
      }
    },

    async syncDataEvent () {
      try {
        this.isSync = true
        try {
          await syncData()
        } catch (e) {
          console.log(e, 'error')
        }
        await this.loadStore()
        this.isSync = false
      } catch (e) {

      }
    },
    visitWeb () {
      window.open(this.takeawayAddress)
    },

    getNewImgUrl (val) {
      this.webInfo.bannerImagePath = val
    }

  }
}
</script>

<style scoped>
.editImgClass:hover {
  cursor: pointer;
}

.switchClass {
  switch-width: 80px
}
</style>
